module.exports = __webpack_public_path__ + "img/careers_video_poster.1b826aae.png";